export default class CONSTANTS {
    static VERSION_NUMBER = 2303.1

    static REFRESH_TOKEN_PERIOD = 14 //in days

    static POINTS_INCREMENT = 1

    static REDEEMING_PERIOD = {
        MIN: 5,  // 5 minutes
        SEC: 300 // 5 minutes in seconds
    }

    static REDEMPTION_PERIOD = {
        DAY: 30,     // 30 days
        SEC: 2592000 // 30 days * 86400 secs/day
    }

    static INTERVAL_CACHING= {
        SEC: 120, // 60 * 2 (in seconds),
        MS: 120000
    }

    static USER_TYPES = {
        INDIVIDUAL: 0,
        BUSINESS: 1,
        ESTABLISHMENT: 2,
        SUPERUSER: 3
    }

    static ENDPOINT_TYPES = {
        UNDEFINED: -1,
        EMAIL: 0,
        PHONE: 1,
        ADDRESS: 2,
        TWITTER: 3,
        FACEBOOK: 4,
        YELP: 5,
        IDENTITY: 6,
        WIDGET: 7,
        FOLLOWERS: 8,
        WEBSITE: 9,
        LINK: 10,
        PROSPECT_EMAIL: 11,
        PROSPECT_PHONE: 12
    }

    static CARD_TYPES = {
        VI: 'Visa',
        VISA: 'Visa',
        MC: 'Mastercard'
    }
}



// WEBPACK FOOTER //
// ./src/constants/constants.js